import { AlertTriangle, Check, Circle, PauseCircle } from 'lucide-react';
import type { SyncActivitySummary } from '@/shared/api';

/**
 * Zusammenfassung des Austauschs. Vorher standen dort die rohen Vendor-Zustände („processed",
 * „failed (7d)") mit Unicode-Zeichen als Symbol; jetzt deutsche Wörter und Lucide-Symbole.
 */
export function SyncActivitySummaryPill({ summary }: { summary: SyncActivitySummary }) {
  return (
    <div className="text-ink-soft flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
      <span className="inline-flex items-center gap-1">
        <Check size={12} className="text-sage" aria-hidden />
        {summary.processed} verarbeitet
      </span>
      {summary.pending > 0 && (
        <span className="inline-flex items-center gap-1">
          <Circle size={10} className="text-ink-faint" aria-hidden />
          {summary.pending} in Arbeit
        </span>
      )}
      {summary.failedLast7Days > 0 && (
        <span className="text-sealwax inline-flex items-center gap-1 font-medium">
          <AlertTriangle size={12} aria-hidden />
          {summary.failedLast7Days} gescheitert (7 Tage)
        </span>
      )}
      {summary.parkedActive > 0 && (
        <span className="text-amber inline-flex items-center gap-1">
          <PauseCircle size={12} aria-hidden />
          {summary.parkedActive} zurückgestellt
        </span>
      )}
    </div>
  );
}
